<script>
    import { onMount } from "svelte";
    import { store } from "../../store.js";
    import emailjs from "emailjs-com";
    import Section from "../Common/Section.svelte";
    import LinkButton2 from "../Common/LinkButton2.svelte";
    import Typewriter from "svelte-typewriter";

    import PartnersCarousel from "../Common/PartnersCarousel.svelte";
    import BrandCarousel from "../Common/BrandCarousel.svelte";
    import Roadmap from "../Common/Roadmap.svelte";
    import Contact from "../Common/Contact.svelte";
    import sections from "./sections";

    console.log(sections)

    let brandCarousel, partnersCarousel;
    let y;
    
    onMount(() => {    
        handleAnchorScroll(0);   

        roadmapTop = Number(document.getElementById('roadmap').style.top.replace('px', ''));
        teamTop = Number(document.getElementById('team').style.top.replace('px', ''));
        partnersTop = Number(document.getElementById('partners').style.top.replace('px', ''));
        ecosystemTop = Number(document.getElementById('ecosystem').style.top.replace('px', ''));
        aboutTop = Number(document.getElementById('about').style.top.replace('px', ''));
    });

    function handleAnchorScroll(index) {
        var others = document.getElementsByClassName('anchor');
        
        for(let i = 0; i < others.length; ++i) {
            others[i].classList.remove('active')
        }
        others[index].classList.add('active');        
    }

    let roadmapTop;
    let teamTop;
    let partnersTop;
    let ecosystemTop;
    let aboutTop;

    $: {
        (function() {

            if(y >= (roadmapTop * $store.r)) {
                handleAnchorScroll(4);
                return;
            }
            
            if(y >= (teamTop * $store.r)) {
                handleAnchorScroll(3);
                return;
            }

            if(y >= (partnersTop * $store.r)) {
                handleAnchorScroll(2);
                return;
            }            

            if(y >= (ecosystemTop * $store.r)) {
                handleAnchorScroll(1);
                return;
            }

            if(y >= (aboutTop * $store.r)) {
                handleAnchorScroll(0);
                return;
            }            

        })();
    }

</script>
<svelte:window bind:scrollY={y} />
<section style:position={"relative"}>
    <div class="menu" style={`width: ${$store.r * 350}px; height: ${$store.r * 500}px;`}>
        <!-- <div class="text-center">
            <img src="/images/logo-3.png" alt="logo" style={`width: ${$store.r * 150}px;`}/>
        </div> -->

        <ul style={`padding-left: ${$store.r * 87}px; margin-top: ${$store.r * 215}px;`}>
            <li>
                <a class="anchor" id="first-anchor" href="#about">ABOUT</a>
            </li>
            <li>
                <a class="anchor" href="#ecosystem">ECOSYSTEM</a>
            </li>
            <li>
                <a class="anchor" href="#partners">PARTNERS</a>
            </li>
            <li>
                <a class="anchor" href="#team">TEAM</a>
            </li>
            <li>
                <a class="anchor" href="#roadmap">ROADMAP</a>
            </li>
        </ul>
    </div>

    <Section name="aboutAchor" id="about" styles={sections[$store.type][$store.locale]['aboutAnchor'] || null} />

    <Section
        name="konnect1"
        styles={sections[$store.type][$store.locale]['konnect1'] || null}
    >
        <Typewriter cascade interval={50} cursor={false}>
            <h1 class="slogan font-koho">Beyond Metaverse,</h1>
            <h1 class="slogan font-koho d-inline">Connect Revolution</h1>
            <h1 class="slogan font-koho blink d-inline">_</h1>
        </Typewriter>
    </Section>

    <Section
        name="konnect2"
        styles={sections[$store.type][$store.locale]['konnect2'] || null}
    >
        <div class="project-title">
            PROJECT: <strong>Konnect</strong>
        </div>
        {#if $store.locale === 'en'}
            <div class="project-description">
                With the slogan of 'Connecting vitrual and reality',
                Konnect connects virtual reality and the real economy
                through blockchain. Konnect carries out the mission of
                connecting virtual and reality faster and more transparently.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="project-description">
                '가상과 현실을 잇다'라는 슬로건을 앞선 Konnect는
                블록체인을 통해 가상 현실과 실물 경제를 연결합니다.
                연매출 6조원의 실물 경제 인프라를 블록체인으로 구현한
                멤버십 플랫폼을 통해 누구보다 빠르고 투명하게
                가상과 현실을 잇는 미션을 수행합니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="project-description">
                Với slogan kết nối ảo và thực tế, Konnect kết nối thực tế ảo và nền kinh tế thật thông qua blockchain. 
                Đây là một nền tảng membership kết hợp cơ sở hạ tầng nền kinh tế thật doanh thu hàng năm là 6 nghìn 
                tỷ won với blockchain, đồng thời kết nối thực tế và môi trường ảo nhanh hơn, minh bạch hơn bất kỳ ai khác
            </div>
        {/if}
        
    </Section>

    <Section
        name="konnect3"
        styles={sections[$store.type][$store.locale]['konnect3'] || null}

    >
        <div class="ecosystem-title">
            Konnect Composition
        </div>
    </Section>

    <Section
        name="konnect3-1"
        styles={sections[$store.type][$store.locale]['konnect3-1'] || null}

    >
        {#if $store.locale === 'en'}
            <div class="ecosystem-desc">
                "Konnect consists of 6 core elements"
            </div>
        {:else if $store.locale === 'kr'}
            <div class="ecosystem-desc">
                "Konnect는 6가지 핵심 요소로 구성됩니다"
            </div>
        {:else if $store.locale === 'vn'}
            <div class="ecosystem-desc">
                "'Konnect được cấu thành bởi 6 yếu tố chính"
            </div>
        {/if}
    </Section>

    <Section
        name="konnect4"
        styles={sections[$store.type][$store.locale]['konnect4'] || null}

    >
        <div class="ecosystem-item-title">            
            {#if $store.locale === 'en'}
                <strong># USER</strong> (Konnecter)
            {:else if $store.locale === 'kr'}
                <strong># 사용자</strong> (Konnecter)
            {:else if $store.locale === 'vn'}
                <strong># USER</strong> (Konnecter)
            {/if}
        </div>
    </Section>

    <Section
        name="konnect4-1"
        styles={sections[$store.type][$store.locale]['konnect4-1'] || null}

    >        
        {#if $store.locale === 'en'}
            <div class="ecosystem-item-desc">
                Konnect users get the
                opportunity to participate as
                members of the Konnect World,
                in which participants enjoy
                dynamic benefits and perks in
                bth the virtual and real life.
            </div>
        {:else if $store.locale === 'kr'}           
            <div class="ecosystem-item-desc">
                Konnect의 사용자는 다양한
                실물경제의 혜택과 보상을
                Konnect World의 일원으로
                참여할 기회가 주어집니다.
            </div>
        {:else if $store.locale === 'vn'}           
            <div class="ecosystem-item-desc">
                Người dùng Konnect có cơ hội tham 
                gia với tư cách là thành viên của 
                Konnect World, bao gồm nhiều lợi 
                ích trong nền kinh tế thật.
            </div>
        {/if}
    </Section>

    <Section
        name="konnect4-2"
        styles={sections[$store.type][$store.locale]['konnect4-2'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "kr"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "vn"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : null}
            hide={false}
            href="/kct#membership"
            text= {
                $store.locale === 'en' ? "View MEMBERSHIP" 
                : $store.locale === 'kr' ? "멤버십 알아보기"
                : $store.locale === 'vn' ? "Tìm hiểu về Membership" : "View MEMBERSHIP"
            }
            cursor={false}
            typewriter={false}
            logo={true}
        />
    </Section>

    <Section
        name="konnect5"
        styles={sections[$store.type][$store.locale]['konnect5'] || null}

    >
        
        {#if $store.locale === 'en'}
            <div class="ecosystem-item-title">
                <strong># PARTNERS</strong>
            </div>
        {:else if $store.locale === 'kr'}           
            <div class="ecosystem-item-title">
                <strong># 파트너</strong>
            </div>
        {:else if $store.locale === 'vn'}           
            <div class="ecosystem-item-title">
                <strong># PARTNERS</strong>
            </div>    
        {/if}
    </Section>

    <Section
        name="konnect5-1"
        styles={sections[$store.type][$store.locale]['konnect5-1'] || null}

    >
        {#if $store.locale === 'en'}
            <div class="ecosystem-item-desc">
                Partners to bridge the real-world
                economy together with Konnect.
            </div>
        {:else if $store.locale === 'kr'}  
            <div class="ecosystem-item-desc">
                Konnect World와 실물 경제를
                함께 이어나갈 파트너들입니다.
            </div>
        {:else if $store.locale === 'vn'}  
            <div class="ecosystem-item-desc">
                Là những đối tác sẽ kết nối nền kinh 
                tế thật cùng với Konnect World.
            </div>
        {/if}
    </Section>

    <Section
        name="konnect5-2"
        styles={sections[$store.type][$store.locale]['konnect5-2'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "kr"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "vn"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : null}
            hide={false}
            href="/konnect#partners"
            text= {
                $store.locale === 'en' ? "View PARTNERS" 
                : $store.locale === 'kr' ? "파트너 알아보기"
                : $store.locale === 'vn' ? "Tìm hiểu về đối tác" : "View PARTNERS"
            }
            cursor={false}
            typewriter={false}
            logo={true}
        />
    </Section>

    <!-- 6 -->

    <Section
        name="konnect6"
        styles={sections[$store.type][$store.locale]['konnect6'] || sections[$store.type][$store.locale]['konnect4-0']}

    >
        {#if $store.locale === 'en'}
        <div class="ecosystem-item-title">
            <strong># STORY</strong>
        </div>
        {:else if $store.locale === 'kr'}  
        <div class="ecosystem-item-title">
            <strong># 스토리</strong>
        </div>
        {:else if $store.locale === 'vn'}  
        <div class="ecosystem-item-title">
            <strong># STORY</strong>
        </div>
        {/if}
    </Section>

    <Section
        name="konnect6-1"
        styles={sections[$store.type][$store.locale]['konnect6-1'] || sections[$store.type][$store.locale]['konnect4-01']}

    >        
        {#if $store.locale === 'en'}
            <div class="ecosystem-item-desc">
                Konnect will operate and grow
                the ecosystem based on the
                "Konnect World" story.
                Make sure to stay updated on
                the lastest episodes as we
                reveal the story!
            </div>
        {:else if $store.locale === 'kr'}  
            <div class="ecosystem-item-desc">
                Konnect는 'Konnect World'라는
                가상의 스토리를 바탕으로 유저
                여러분들과 함께 운영해 나갑니다.
                매회 새롭게 밝혀지는 스토리와 함께
                다양한 이벤트에 참여해보세요!
            </div>
        {:else if $store.locale === 'vn'}  
            <div class="ecosystem-item-desc">
                Konnect hoạt động cùng với nhiều người 
                dùng dựa trên câu chuyện giả tưởng có 
                tên "Konnect World". Thử tham gia vào 
                câu chuyện nối tiếp mỗi tập nhé!
            </div>
        {/if}
    </Section>

    <Section
        name="konnect6-2"
        styles={sections[$store.type][$store.locale]['konnect6-2'] || sections[$store.type][$store.locale]['konnect4-02']}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "kr"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "vn"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : null}
            hide={false}
            href="/nft#story"
            text= {
                $store.locale === 'en' ? "View STORIES" 
                : $store.locale === 'kr' ? "스토리 더보기"
                : $store.locale === 'vn' ? "Xem thêm Story" : "View STORIES"
            }
            cursor={false}
            typewriter={false}
            logo={true}
        />
    </Section>

    <!-- /6 -->

    <!-- 7 -->

    <Section
        name="konnect7"
        styles={sections[$store.type][$store.locale]['konnect7'] || sections[$store.type][$store.locale]['konnect4-0']}

    >
        <div class="ecosystem-item-title">
            <strong># KCT</strong>(KONNECT TOKEN)
        </div>        
    </Section>

    <Section
        name="konnect7-1"
        styles={sections[$store.type][$store.locale]['konnect7-1'] || sections[$store.type][$store.locale]['konnect4-01']}

    >        
        {#if $store.locale === 'en'}
            <div class="ecosystem-item-desc">
                KCT is your ticket to the
                Konnect World. Not only does
                KCT provide convenience and
                ease, but also dynamic benefit
                and perks such as discounts
                and reward.
            </div>
        {:else if $store.locale === 'kr'}  
            <div class="ecosystem-item-desc">
                Konnect World로 가는 티켓입니다.
                KCT로 편리함은 물론 할인,
                리워드 등 다양한 보상 및 혜택이
                함께 합니다.
            </div>
        {:else if $store.locale === 'vn'}  
            <div class="ecosystem-item-desc">
                Đây là chiếc vé (coin) đi đến Konnect World. 
                Với KCT, nó không chỉ thuận tiện mà 
                còn đi kèm với nhiều lợi ích thực tế 
                như giảm giá, quà tặng.
            </div>
        {/if}
    </Section>

    <Section
        name="konnect7-2"
        styles={sections[$store.type][$store.locale]['konnect7-2'] || sections[$store.type][$store.locale]['konnect4-02']}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "kr"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "vn"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : null}
            hide={false}
            href="/kct"
            text= {
                $store.locale === 'en' ? "View KCT" 
                : $store.locale === 'kr' ? "KCT 알아보기"
                : $store.locale === 'vn' ? "Tìm hiểu về KCT" : "View KCT"
            }
            cursor={false}
            typewriter={false}
            logo={true}
        />
    </Section>

    <!-- /7 -->

    <!-- 8 -->

    <Section
        name="konnect8"
        styles={sections[$store.type][$store.locale]['konnect8'] || sections[$store.type][$store.locale]['konnect4-0']}

    >
        {#if $store.locale === 'en'}
            <div class="ecosystem-item-title">
                <strong># NFT Marketplace</strong>
            </div>
        {:else if $store.locale === 'kr'}  
            <div class="ecosystem-item-title">
                <strong># NFT 마켓플레이스</strong>
            </div>
        {:else if $store.locale === 'vn'}  
            <div class="ecosystem-item-title">
                <strong># NFT Marketplace</strong>
            </div>
        {/if}
    </Section>

    <Section
        name="konnect8-1"
        styles={sections[$store.type][$store.locale]['konnect8-1'] || sections[$store.type][$store.locale]['konnect4-01']}

    >
        {#if $store.locale === 'en'}
            <div class="ecosystem-item-desc">
                You can purchase and
                transace NFTs minted in the
                Konnect World.
                Take a look at our mystery boxes
                tied with luxury brand products
                and our DUMAN PFP NFTs!
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="ecosystem-item-desc">
                Konnect World에서 다양하게
                사용되는 KCT NFT를 구매할 수
                있습니다.
                명품 브랜드 미스테리 박스,
                DUMAN PFP NFT 등 NFT를 만나보세요.
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="ecosystem-item-desc">
                Bạn có thể mua NFT của Konnect World.
                Thử gặp gỡ Mystery box của thương hiệu 
                danh tiếng, DUMAN's PFP nhé.
            </div>
        {/if}
    </Section>

    <Section
        name="konnect8-2"
        styles={sections[$store.type][$store.locale]['konnect8-2'] || sections[$store.type][$store.locale]['konnect4-02']}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "kr"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "vn"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : null}
            hide={false}
            href="/nft"
            text= {
                $store.locale === 'en' ? "View NFT Market" 
                : $store.locale === 'kr' ? "NFT 마켓 바로가기"
                : $store.locale === 'vn' ? "Đi đến NFT Market" : "View NFT Market"
            }
            cursor={false}
            typewriter={false}
            logo={true}
        />
    </Section>

    <!-- /8 -->

    <!-- 9 -->

    <Section
        name="konnect9"
        styles={sections[$store.type][$store.locale]['konnect9'] || sections[$store.type][$store.locale]['konnect4-0']}

    >
        {#if $store.locale === 'en'}
            <div class="ecosystem-item-title">
                <strong># E-COMMERCE</strong>
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="ecosystem-item-title">
                <strong># 이커머스</strong>
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="ecosystem-item-title">
                <strong># E-COMMERCE</strong>
            </div>
        {/if}
    </Section>

    <Section
        name="konnect9-1"
        styles={sections[$store.type][$store.locale]['konnect9-1'] || sections[$store.type][$store.locale]['konnect4-01']}

    >
        {#if $store.locale === 'en'}
            <div class="ecosystem-item-desc">
                You can find Konnect World's
                luxury brand offerings and
                stores online.
                Of course, benefits and perks
                are also provided!
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="ecosystem-item-desc">
                Konnect World의 명품 브랜드
                매장을 온라인에서 만나실 수 
                있습니다.
                할인과 혜택은 당연하겠죠?
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="ecosystem-item-desc">
                Bạn có thể tìm thấy các cửa hàng thương hiệu 
                nổi tiếng của Konnect World trực tuyến.
                Dĩ nhiên là được giảm giá và ưu đãi rồi :)
            </div>
        {/if}
    </Section>

    <Section
        name="konnect9-2"
        styles={sections[$store.type][$store.locale]['konnect9-2'] || sections[$store.type][$store.locale]['konnect4-02']}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "kr"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : $store.locale === "vn"
                ? { width: 300, height: 50, 'font-size': '1vw' }
                : null}
            hide={false}
            onClick={()=>alert('Getting ready!')}
            text= {
                $store.locale === 'en' ? "View E-Commerce" 
                : $store.locale === 'kr' ? "이커머스 알아보기"
                : $store.locale === 'vn' ? "Tìm hiểu về E-Commerce" : "View E-Commerce"
            }
            cursor={false}
            typewriter={false}
            logo={true}
        />
    </Section>

    <!-- /9 -->    
    
    <Section name="ecosystemAnchor" id="ecosystem" styles={sections[$store.type][$store.locale]['ecosystemAnchor'] || null} />


    <Section
        name="konnect18"
        styles={sections[$store.type][$store.locale]['konnect18'] || null}
    >
        <Typewriter cascade loop={true} interval={100} cursor={false}>
            <h1 class="slogan font-koho">ECOSYSTEM</h1>
        </Typewriter>
    </Section>

    <Section
        name="konnect19"
        styles={sections[$store.type][$store.locale]['konnect19'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="common-title">
                Infrastructure of <span class="highlight">'4.6 billion USD'</span> in sales secured
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-title">
                이미 확보된 Konnect 실물경제 인프라, <span class="highlight">'6조원'</span>
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-title">
                Cơ sở hạ tầng nền kinh tế thật của Konnect đã được bảo đảm, <span class="highlight">'6 nghìn tỷ won'</span>
            </div>
        {/if}
    </Section>

    <Section
        name="konnect20"
        styles={sections[$store.type][$store.locale]['konnect20'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="common-desc">
                <span class="title">'We do not want risky adventures'</span>
                Konnect has a proven track-record of an Infrastructure capable of generating $6B+ USD in annual sales and meeting customer demands. With an already established network, resources, and Infrastructure, Konnect will be able to quickly build the real-world based token ecosystem.
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-desc">
                <span class="title">'우리는 위험한 모험을 하지 않습니다'</span>
                Konnect는 '연매출 6조원' 이상을 창출하고 있으며, 가상화폐의 도입으로 더욱 성장할 수 있는 실물경제의 인프라 실적을 보유하고 있습니다. 이미 구축된 인프라를 기반으로 Konnect는 실물경제 기반의 가상화폐 생태계를 누구보다 투명하고 신속하게 만들어 가겠습니다.
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-desc">
                <span class="title">'Chúng tôi không thực hiện những cuộc phiêu lưu mạo hiểm'</span>
                Konnect tạo ra hơn 6 nghìn tỷ won doanh thu hàng năm và có hiệu suất cơ sở hạ tầng trong nền kinh tế thật sẽ phát triển hơn nữa thông qua việc kết hợp tiền ảo. Dựa trên cơ sở hạ tầng đã được thiết lập sẵn, Konnect sẽ tạo ra một hệ sinh thái tiền ảo dựa trên nền kinh tế thật một cách minh bạch và nhanh chóng hơn bất kỳ ai khác.
            </div>
        {/if}
    </Section>

    <Section
        name="konnect21"
        styles={sections[$store.type][$store.locale]['konnect21'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="membership-title">Target Market Annual Sales</div>
        {:else if $store.locale === 'kr'} 
            <div class="membership-title">타켓시장의 연매출</div>
        {:else if $store.locale === 'vn'} 
            <div class="membership-title">Doanh số hàng năm của thị trường mục tiêu</div>
        {/if}
        <div class="membership-item">$4.6B+</div>
    </Section>

    <Section
        name="konnect21-1"
        styles={sections[$store.type][$store.locale]['konnect21-1'] || sections[$store.type][$store.locale]['konnect21']}
    >
        {#if $store.locale === 'en'}
            <div class="common-desc">
                Of the global market with $82.2B,
                Konnect has secured more than $4.6B in transaction volume with its partners
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-desc">
                면세 유통 글로벌 시장 규모는 822억 달러이며,
                이중 Konnect는 파트너와 함께 134억 달러 이상의 거래량을 확보했습니다.
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-desc">
                Quy mô thị trường phân phối miễn thuế toàn cầu là 82,2 tỷ đô la, 
                trong đó Konnect đã đảm bảo khối lượng giao dịch hơn 13,4 tỷ USD cùng với các đối tác của mình.
            </div>
        {/if}
    </Section>

    <Section
        name="konnect22"
        styles={sections[$store.type][$store.locale]['konnect22'] || null}
    >
        <div class="membership-title">User</div>
        <div class="membership-item">B2B 3M+</div>
        <div class="membership-item">B2C 200K+</div>
    </Section>

    <Section
        name="konnect22-1"
        styles={sections[$store.type][$store.locale]['konnect22-1'] || sections[$store.type][$store.locale]['konnect22']}
    >
        {#if $store.locale === 'en'}
            <div class="common-desc">
                Konnect and its partners already have
                over 3 million users in B2B and B2C combined
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-desc">
                Konnect와 파트너들은 이미 B2B와 B2C를 합친
                300만명 이상의 사용자를 확보하고 있습니다.
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-desc">
                Konnect và các đối tác đã có hơn 
                3 triệu người dùng kết hợp B2B và B2C.
            </div>
        {/if}
    </Section>

    <Section
        name="konnect23"
        styles={sections[$store.type][$store.locale]['konnect23'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="membership-title">Country</div>
        {:else if $store.locale === 'kr'} 
            <div class="membership-title">국가</div>
        {:else if $store.locale === 'vn'} 
            <div class="membership-title">Quốc gia</div>

        {/if}
        <div class="membership-item">15+</div>        
    </Section>

    <Section
        name="konnect23-1"
        styles={sections[$store.type][$store.locale]['konnect23-1'] || sections[$store.type][$store.locale]['konnect23']}
    >
        {#if $store.locale === 'en'}            
            <div class="common-desc">
                Konnect has business Infrastructure in
                more than 15 countries, including the
                United States, China, the European Union (EU),
                Australia, Vietnam, and Indoesia
                in the current duty-free distribution
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-desc">
                Konnect에는 기존 명세 유통에서의 비즈니스
                인프라가 있습니다. 미국, 중국, 유럽연합(EU),
                호주, 베트남, 인도네시아를 포함하여 15개국
                이상의 국가와 할발한 거래중에 있습니다.
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-desc">
                Konnect có cơ sở hạ tầng thương mại trong phân phối miễn thuế cơ bản. Chúng tôi đang tích cực giao dịch với hơn 15 quốc gia bao gồm Mỹ, Trung Quốc, Liên minh Châu Âu (EU), Úc, Việt Nam và Indonesia.
            </div>
        {/if}
    </Section>

    <Section
        name="konnect25"
        styles={sections[$store.type][$store.locale]['konnect25'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="membership-title">Goods</div>
        {:else if $store.locale === 'kr'} 
            <div class="membership-title">상품수</div>
        {:else if $store.locale === 'vn'} 
            <div class="membership-title">Số lượng sản phẩm</div>
        {/if}
        <div class="membership-item">60K+</div>
    </Section>
    
    <Section
        name="konnect25-1"
        styles={sections[$store.type][$store.locale]['konnect25-1'] || sections[$store.type][$store.locale]['konnect25']}
    >
        {#if $store.locale === 'en'}
            <div class="common-desc">
                Konnect and its partners handle
                more than 60,000 top brand products
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-desc">
                Konnect와 파트너는 60,000개 이상의 
                최고의 브랜드 제품을 취급합니다.
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-desc">
                Konnect và các đối tác đã và đang giao dịch 
                hơn 60.000 sản phẩm của các thương hiệu hàng đầu.
            </div>
        {/if}
    </Section>

    <Section
        name="konnect26"
        styles={sections[$store.type][$store.locale]['konnect26'] || sections[$store.type][$store.locale]['konnect25']}
    >
        <div class="ecosystem-item-title">
            <strong># Brands We Have</strong>
        </div>
    </Section>
    
    <Section
        name="konnect47"
        type="carousel"
        styles={sections[$store.type][$store.locale]['konnect47'] || null}
    >
        <BrandCarousel bind:carousel={brandCarousel} />
    </Section>

    <Section name="partnersAnchor" id="partners" styles={sections[$store.type][$store.locale]['partnersAnchor'] || null} />


    <Section
        name="konnect47-2"
        styles={sections[$store.type][$store.locale]['konnect47-2'] || sections[$store.type][$store.locale]['konnect47']}
    >
        <div class="allocation-title">50+ PARTNERS</div>
    </Section>

    <Section
        name="konnect48"
        type="carousel"
        styles={sections[$store.type][$store.locale]['konnect48'] || null}
    >
        <PartnersCarousel imageWidth={175} bind:carousel={partnersCarousel} />
    </Section>

    <Section
        name="konnect49"
        type="arrows"
        styles={sections[$store.type][$store.locale]['konnect49'] || null}
    >
        <i
            on:click={() => partnersCarousel.goToPrev()}
            class="bi bi-chevron-left partners-arrow"
        />

        <div class="d-inline-block" style={`width: ${$store.r * 150}px`} />

        <i
            on:click={() => partnersCarousel.goToNext()}
            class="bi bi-chevron-right partners-arrow"
        />
    </Section>

    <!-- <Section
        name="konnect51"
        styles={sections[$store.type][$store.locale]['konnect51'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="common-desc">
                "We are creating a new world with diverse and powerful partners in the real economy"
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-desc">
                "우리는 실물 경제의 강력하고 다양한 파트너들과 함께 새로운 세상을 만들어 갑니다"
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-desc">
                "Chúng tôi đang tạo ra một thế giới mới cùng với các đối tác đa dạng và lớn mạnh trong nền kinh tế thật"
            </div>
        {/if}
    </Section> -->

    <!-- <Section
        name="konnect51-2"
        styles={sections[$store.type][$store.locale]['konnect51-2'] || sections[$store.type][$store.locale]['konnect51']}
    >
        {#if $store.locale === 'en'}
            <div class="common-desc">
                To connect the real economy with virtual currency, Koneect works with more than 50 partners.
                To promote growth of Konnect World, we will collabarate with more partners as we move forward.
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-desc">
                실물 경제와 가상 화폐를 연결하기 위해 Konnect는 50개 이상의 파트너와 협력하고 있습니다.
                Konnect World의 빠른 성장을 위해 앞으로도 더 많은 파트너들과 함께 미래를 구축할 것입니다.
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-desc">
                Konnect đang làm việc với hơn 50 đối tác để kết nối nền kinh tế thật với tiền ảo.
                Vì sự phát triển nhanh chóng của Konnect World, chúng tôi sẽ tiếp tục tạo ra tương lai cùng với nhiều đối tác hơn nữa.
            </div>
        {/if}
    </Section> -->

    <!-- TEAM STARTS -->

    <Section name="teamAnchor" id="team" styles={sections[$store.type][$store.locale]['teamAnchor'] || null} />


    <Section
        name="konnect27"
        styles={sections[$store.type][$store.locale]['konnect27'] || sections[$store.type][$store.locale]['konnect51']}
    >
        <div class="allocation-title font-koho">Konnect Team</div>
    </Section>

    <Section
        name="konnect28-1"
        styles={sections[$store.type][$store.locale]['konnect28-1'] || sections[$store.type][$store.locale]['konnect25']}
    >
        <div class="team-title">
            <strong>Jun Seok Kim [CEO]</strong>
        </div>
    </Section>

    <Section
        name="konnect28-2"
        styles={sections[$store.type][$store.locale]['konnect28-2'] || sections[$store.type][$store.locale]['konnect25']}

    >        
        {#if $store.locale === 'en'}            
            <div class="team-desc">
                - University of Minnesota Law School
                - '94 - '01 Haitai International Inc. Associate Legal Manager
                - '03 - '13 Hynix Semiconductor Inc. Associate
                - '13 Yahoo Korea / Overture Korea Deputy General Counsel
                / Policy Advisor
                - '13 Kim & Chang Advisor
                - '17 - Current Joowon Law Firm Partner
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="team-desc">
                - University of Minnesota Law School
                - '94 - '01 Haitai International Inc. 준법률 관리자
                - '03 - '13 Hynix Semiconductor Inc. 어소시에이트
                - '13 야후 코리아 / 오버추어 코리아 법무차관 / 정책자문위원
                - '13 김&장 고문
                - '17 - 현재 주원 로펌 파트너
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="team-desc">
                - University of Minnesota Law School
                - '94 - '01 Haitai International Inc. Associate Legal Manager
                - '03 - '13 Hynix Semiconductor Inc. Associate
                - '13 Yahoo Korea / Overture Korea Deputy General Counsel
                / Policy Advisor
                - '13 Kim & Chang Advisor
                - '17 - Current Joowon Law Firm Partner
            </div>    
        {/if}
    </Section>

    <Section
        name="konnect29-1"
        styles={sections[$store.type][$store.locale]['konnect29-1'] || sections[$store.type][$store.locale]['konnect28-1']}
    >
        <div class="team-title">
            <strong>Jürgen Kob [CMO]</strong>
        </div>
    </Section>

    <Section
        name="konnect29-2"
        styles={sections[$store.type][$store.locale]['konnect29-2'] || sections[$store.type][$store.locale]['konnect28-1']}

    >        
        {#if $store.locale === 'en'}  
            <div class="team-desc">
                - Member of Bitcoin Association Switzerland
                - Member of Crypto Valley Association & Crypto Valley Lab
                - Member of FINTECH Circle Institute, London, UK
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="team-desc">
                - 스위스 비트코인 연합
                (Bitcoin Association Switzerland) 회원
                - Crypto Valley Association & Crypto Valley Lab 회원
                - FINTECH Circle Institute, London, UK 회원
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="team-desc">
                - Member of Bitcoin Association Switzerland
                - Member of Crypto Valley Association & Crypto Valley Lab
                - Member of FINTECH Circle Institute, London, UK
            </div>
        {/if}
    </Section>

    <Section
        name="konnect30-1"
        styles={sections[$store.type][$store.locale]['konnect30-1'] || sections[$store.type][$store.locale]['konnect28-1']}
    >
        <div class="team-title">
            <strong>Mark Jung [CTO]</strong>
        </div>
    </Section>

    <Section
        name="konnect30-2"
        styles={sections[$store.type][$store.locale]['konnect30-2'] || sections[$store.type][$store.locale]['konnect28-1']}

    >        
        {#if $store.locale === 'en'}  
            <div class="team-desc">
                - University of Utah, Electrical Engineering
                - Various experiences in IT and blockchain industries
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="team-desc">
                - University of Utah, Electrical Engineering
                - 다양한 전통 산업군 및 블록체인 관련 서비스 경험
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="team-desc">
                - University of Utah, Electrical Engineering
                - Various experiences in IT and blockchain industries
            </div>
        {/if}
    </Section>

    <Section
        name="konnect31-1"
        styles={sections[$store.type][$store.locale]['konnect31-1'] || sections[$store.type][$store.locale]['konnect28-1']}
    >
        <div class="team-title">
            <strong>Serena Yun [COO]</strong>
        </div>
    </Section>

    <Section
        name="konnect31-2"
        styles={sections[$store.type][$store.locale]['konnect31-2'] || sections[$store.type][$store.locale]['konnect28-1']}

    >        
        {#if $store.locale === 'en'}  
            <div class="team-desc">
                - '17 - 20' Co-founder of Heritage Blocks,
                in charge of marketing various projects in Korea
                - '21 Custody Analyst for the Korbit Exchange
                - '22 COO for Konnect project
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="team-desc">
                - '17 - 20' 헤리티지 블록 공동 설립자, 한국 내 다양한
                마케팅 프로젝트 경험
                - '21 코빗(Korbit) 거래소 커스터디 애널리스트
                - '22 Konnect 프로젝트 COO
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="team-desc">
                - '17 - 20' Co-founder of Heritage Blocks,
                in charge of marketing various projects in Korea
                - '21 Custody Analyst for the Korbit Exchange
                - '22 COO for Konnect project
            </div>
        {/if}
    </Section>

    <Section
        name="konnect32-1"
        styles={sections[$store.type][$store.locale]['konnect32-1'] || sections[$store.type][$store.locale]['konnect28-1']}
    >
        <div class="team-title">
            <strong>David Hong [CSO]</strong>
        </div>
    </Section>

    <Section
        name="konnect32-2"
        styles={sections[$store.type][$store.locale]['konnect32-2'] || sections[$store.type][$store.locale]['konnect28-1']}

    >        
        {#if $store.locale === 'en'}  
            <div class="team-desc">
                - Master of International Commerce, Graduate School of
                International Studies, Seoul National University
                - 1st place in 2019 Cosmos Hack Atom Seoul Defi Category
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="team-desc">
                - 서울대학교 국제대학원 국제통상 석사
                - '19 Cosmos HackAtom Seoul Defi Category 1위
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="team-desc">
                - Master of International Commerce, Graduate School of
                International Studies, Seoul National University
                - 1st place in 2019 Cosmos Hack Atom Seoul Defi Category
            </div>
        {/if}
    </Section>


    <!-- TEAM ENDS -->

    <Section name="roadmapAnchor" id="roadmap" styles={sections[$store.type][$store.locale]['roadmapAnchor'] || null} />

    <Section
        name="konnect52"
        styles={sections[$store.type][$store.locale]['konnect52'] || null}
    >
        <div class="roadmap-title">
            ROADMAP
        </div>
    </Section>
    

    <Section
        name="konnect53"
        type="arrows"
        styles={sections[$store.type][$store.locale]['konnect53'] || null}
    >
        <Roadmap />
    </Section>

</section>

<style>
    .slogan {
        margin: 0 !important;
        font-weight: 700;
        letter-spacing: -1px;
        font-size: 3.5vw;
    }

    .project-title {
        font-size: 1.7vw;
    }

    .project-description {
        font-size: 1.2vw;
        line-height: 2.5vw;
    }

    .ecosystem-title {
        font-size: 2.5vw;
        font-family: 'sandoll-gothivneo1';
        font-weight: 500;
    }

    .ecosystem-desc {
        font-size: 1.3vw;
        font-family: 'sandoll-gothivneo1';
        line-height: 2.2vw;
        color: #6d6e6e;
        white-space: pre-line;
    }

    .ecosystem-item-title {
        font-size: 1.5vw;
        font-family: 'sandoll-gothivneo1';
        letter-spacing: -0.5px;
    }

    .ecosystem-item-desc {
        font-size: 1.1vw;
        letter-spacing: -0.5px;
        color: #6d6e6e;
        line-height: 2vw;
    }

    .sub-slogan {
        font-size: 1.28vw;
        font-weight: 500;
        text-align: center;
    }

    .slogan2 {
        font-size: 3vw;
        text-align: center;
        color: white;
    }

    .slogan2 .accent {
        text-shadow: 0 0 3px #fff, 0 0 3px #fff, 0 0 3px #ffffff, 0 0 3px #ffffff, 0 0 3px #ffffff, 0 0 3px #ffffff, 0 0 3px #ffffff;
        font-weight: 800;
    }

    .slogan3 {
        font-family: koho;
        font-size: 3.1vw;
        text-align: center;
        color: #2d567a;
    }

    .about-title {
        color: #19195b;
        font-size: 2.3vw;
        font-weight: 500;
        letter-spacing: 0;
        font-family: 'sandoll-gothivneo1';
    }

    .about-desc {
        color: #616262;
        font-size: 1.2vw;
        text-align: center;
        line-height: 2.3vw;
        letter-spacing: -0.01vw;
        font-family: 'sandoll-gothivneo1';
        
        white-space: pre-line;
    }

    .nft-title {
        font-size: 2.015vw;
        font-family: 'sandoll-gothivneo1';
        font-weight: 500;
    }

    .common-title {
        font-size: 2.015vw;
        font-family: 'sandoll-gothivneo1';
        font-weight: 400;
        letter-spacing: -0.5px;
    }

    .allocation-title, .roadmap-title, .contact-title {
        font-size: 3.15vw;
        font-family: 'sandoll-gothivneo1';
        font-weight: 500;
        letter-spacing: -0.5px;
    }

    .common-title .highlight {
        font-size: 2.25vw;
        font-weight: bold;
        background-color: #f3d341;
    }

    .common-desc {
        font-size: 1.23vw;
        font-family: 'sandoll-gothivneo1';
        letter-spacing: -0.5px;
        line-height: 2.2vw;
        color: #6d6e6e;
        white-space: pre-line;
    }

    .team-title {
        font-size: 1.5vw;
        font-family: koho;
        letter-spacing: -0.5px;
    }

    .team-desc {
        font-size: 1.1vw;
        font-family: 'sandoll-gothivneo1';
        letter-spacing: -0.5px;
        line-height: 2.2vw;
        color: #6d6e6e;
        white-space: pre-line;
    }

    .membership-desc {
        line-height: 2.2vw;
    }

    .list-title {
        font-size: 2.2vw;
        font-weight: bold;
        font-family: 'sandoll-gothivneo1';
    }

    .list-item {
        white-space: pre-line;
        font-size: 1.5vw;
        letter-spacing: -2px;
        font-family: 'sandoll-gothivneo1';
    }

    .story-title {
        font-weight: 400;
        font-size: 2vw;
        font-family: 'sandoll-gothivneo1';
    }

    .membership-title {
        font-size: 1.5vw;
        font-weight: 400;
        font-family: 'sandoll-gothivneo1';
    }

    .membership-title::before {
        width: 0.5vw;
        height: 1vw;
        margin-right: 0.4vw;
        content: '';
        background-color: #8dd7de;
        display: inline-block;
    }

    .membership-item {
        font-size: 4vw;
        font-weight: 600;
    }

    .story-item {
        white-space: pre-line;
        font-weight: 200;
        font-size: 1.2vw;
        line-height: 2.2vw;
        font-family: 'sandoll-gothivneo1';
    }

    .common-desc .title {

    }

    .question {
        font-size: 3.5vw;
        font-weight: 500;
        letter-spacing: -1px;
    }

    .partners-arrow {
        font-size: 5vw;
        margin-top: -2vw;
        cursor: pointer;
    }

    .menu {
        display: inline-block;
        position: fixed;
        left: 0;
        width: 350px;
        top: 60px;
        height: 500px;
    }

    .menu ul {
        list-style-type: none;
        padding-left: 87px;
        margin-top: 65px;
    }

    .menu ul::before{
        content: '';
        display: block;
        width: 50%;
        border: 1px solid black;
        margin-bottom: 20px;
    }

    .menu ul li {
        font-size: 1.2vw;
        margin-bottom: 10px;
        letter-spacing: -1px;
    }

    .menu ul li a {
        color: inherit;
        text-decoration: inherit;
    }

    :global(.menu ul li a.active) {
        font-weight: bold;
    }

    .menu ul li a:active, .menu ul li a:focus {
        font-weight: bold;
        outline: none;
        box-shadow: none;
    }

</style>
